import { useCallback, useEffect, useMemo, useState } from 'react';
import { YAxisProps } from 'recharts';

interface IYAxisDataItem {
  value?: string | number;
}

const DEFAULT_WIDTH = 40;
const OFFSET = 12;

export const useYAxisWidth = (
  data: IYAxisDataItem[],
  yAxisTickFormatter?: YAxisProps['tickFormatter'],
) => {
  const [yAxisWidth, setYAxisWidth] = useState(DEFAULT_WIDTH);

  const maxLabel = useMemo(
    () =>
      data.reduce(
        (max: string | number, item: IYAxisDataItem, currentIndex) => {
          const value = item.value || 0;
          const formattedValue = yAxisTickFormatter
            ? yAxisTickFormatter(value, currentIndex)
            : value;

          return formattedValue.toString().length > max.toString().length
            ? formattedValue
            : max;
        },
        '',
      ),
    [data, yAxisTickFormatter],
  );

  const calculateWidth = useCallback(() => {
    const tempSpan = document.createElement('span');
    tempSpan.style.visibility = 'hidden';
    tempSpan.style.position = 'absolute';
    tempSpan.style.whiteSpace = 'nowrap';
    tempSpan.textContent = maxLabel.toString();
    document.body.appendChild(tempSpan);

    const width = tempSpan.offsetWidth + OFFSET; // Add some padding
    setYAxisWidth(width);
    document.body.removeChild(tempSpan);
  }, [maxLabel]);

  useEffect(() => {
    if (!data || data.length === 0) return;

    calculateWidth();
  }, [calculateWidth, data]);

  return yAxisWidth;
};
